<div class="p-4">

  <!--Header-->

  @if (title) {
    <h1 class="text-center header mb-3">{{title | translate}}</h1>
  }

  @if (actionLogMetadata) {
    <mat-accordion>
      @for (metadata of actionLogMetadata.list; track metadata) {
        <mat-expansion-panel #m [ngClass]="m.expanded? metadata.historyDetailPanelClass : ''"
          >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fas fa-circle" [class]="metadata.actionIndicatorClass"></i>
              <div class="ml-2" style="font-family: 'Poppins, sans-serif';"> {{metadata.title | translate}} </div>
              <div class="action-indicator ml-4" [class]="metadata.actionIndicatorClass"> {{metadata.action | translate}}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (m.expanded) {
            <div>
              @for (detail of metadata.actionLogDetailList; track detail) {
                <div class="d-flex">
                  <div style="flex: 0 0 250px;">{{detail.key | translate}}</div>
                  <div class="col" style="flex:1">{{detail.value | translate}}</div>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

  @if (actionLogMetadata && actionLogMetadata.list && actionLogMetadata.list.length! > 0) {
    <mat-paginator class="mt-2" style="background: transparent;" [length]="length" [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      (page)="pageChange.emit($event)" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [attr.aria-label]="">
    </mat-paginator>
  }

  <!--No Data Container-->
  @if ((!actionLogMetadata?.list || (actionLogMetadata?.list && actionLogMetadata?.list?.length==0)) && !!actionLogMetadata?.isLoaded) {
    <app-no-record-container
      message="{{ 'campaign_apr_page.document_history_detail.no_data_found_msg' | translate }}">
    </app-no-record-container>
  }

</div>